module.exports = __webpack_public_path__ + "img/case8.93fbbc3f.png";